import Imprint from 'screens/Imprint'

export default Imprint
